import React, { useState } from "react";
import {
  UploadButtonWrapper,
  UploadButton,
  UploadImageWrapper,
  PreviewImageWrapper,
  PreviewImageContainer,
  PreviewImageColumnContainer,
  PreviewImageHalf,
  PreviewImage,
  MoreImage,
} from "./UploadImageStyled";

const UploadImage = () => {
  const [file, setFile] = useState([]);
  function uploadFile(e) {
    setFile(e.target.files);
  }
  console.log(file);

  return (
    <>
      <UploadImageWrapper>
        {file.length !== 0 ? (
          <PreviewImageWrapper>
            {Array.from(file)
              .slice(0, 2)
              .map((image, index) => (
                <>
                  {file.length <= 2 ? (
                    <PreviewImageContainer key={index}>
                      <PreviewImage
                        src={image ? URL.createObjectURL(image) : null}
                      />
                    </PreviewImageContainer>
                  ) : null}
                  {file.length >= 3 && (
                    <>
                      {index === 0 ? (
                        <PreviewImageContainer style={{ width: "230%" }}>
                          <PreviewImage
                            src={image ? URL.createObjectURL(file[0]) : null}
                          />
                        </PreviewImageContainer>
                      ) : (
                        <PreviewImageColumnContainer>
                          <PreviewImageHalf>
                            <PreviewImage
                              src={image ? URL.createObjectURL(file[1]) : null}
                            />
                          </PreviewImageHalf>
                          <PreviewImageHalf>
                            {file.length>3 && <MoreImage>+{file.length-3}</MoreImage>}
                            <PreviewImage
                              src={image ? URL.createObjectURL(file[2]) : null}
                            />
                          </PreviewImageHalf>
                        </PreviewImageColumnContainer>
                      )}
                    </>
                  )}
                </>
              ))}
          </PreviewImageWrapper>
        ) : null}
        <UploadButtonWrapper>
          {file.length !== 0 ? null : "Attachments"}
          <input
            type="file"
            multiple
            id="select-image"
            style={{ display: "none" }}
            onChange={uploadFile}
          ></input>
          <label htmlFor="select-image">
            <UploadButton>CHOOSE</UploadButton>
          </label>
        </UploadButtonWrapper>
      </UploadImageWrapper>
    </>
  );
};

export default UploadImage;
